// Ország-választó opciók a UI nyelvén (lokalizált NÉV; a form a KÓDOT tárolja). Nincs hozzá DB-tábla —
// az Odin `country_code` sima oszlop —, a kód→név a böngésző natív `Intl.DisplayNames`-ével történik
// (ugyanaz, amit a lista-oszlop is használ). A combobox erre a teljes ISO 3166-1 alpha-2 halmazra keres.
import { type ComboboxOption } from '@/components/shared/entity-combobox';

// ISO 3166-1 alpha-2 kódok (teljes, hivatalos halmaz). A megjelenített nevet a locale adja.
// prettier-ignore
const ISO_ALPHA2: readonly string[] = [
  'AD','AE','AF','AG','AI','AL','AM','AO','AQ','AR','AS','AT','AU','AW','AX','AZ',
  'BA','BB','BD','BE','BF','BG','BH','BI','BJ','BL','BM','BN','BO','BQ','BR','BS','BT','BV','BW','BY','BZ',
  'CA','CC','CD','CF','CG','CH','CI','CK','CL','CM','CN','CO','CR','CU','CV','CW','CX','CY','CZ',
  'DE','DJ','DK','DM','DO','DZ',
  'EC','EE','EG','EH','ER','ES','ET',
  'FI','FJ','FK','FM','FO','FR',
  'GA','GB','GD','GE','GF','GG','GH','GI','GL','GM','GN','GP','GQ','GR','GS','GT','GU','GW','GY',
  'HK','HM','HN','HR','HT','HU',
  'ID','IE','IL','IM','IN','IO','IQ','IR','IS','IT',
  'JE','JM','JO','JP',
  'KE','KG','KH','KI','KM','KN','KP','KR','KW','KY','KZ',
  'LA','LB','LC','LI','LK','LR','LS','LT','LU','LV','LY',
  'MA','MC','MD','ME','MF','MG','MH','MK','ML','MM','MN','MO','MP','MQ','MR','MS','MT','MU','MV','MW','MX','MY','MZ',
  'NA','NC','NE','NF','NG','NI','NL','NO','NP','NR','NU','NZ',
  'OM',
  'PA','PE','PF','PG','PH','PK','PL','PM','PN','PR','PS','PT','PW','PY',
  'QA',
  'RE','RO','RS','RU','RW',
  'SA','SB','SC','SD','SE','SG','SH','SI','SJ','SK','SL','SM','SN','SO','SR','SS','ST','SV','SX','SY','SZ',
  'TC','TD','TF','TG','TH','TJ','TK','TL','TM','TN','TO','TR','TT','TV','TW','TZ',
  'UA','UG','UM','US','UY','UZ',
  'VA','VC','VE','VG','VI','VN','VU',
  'WF','WS',
  'YE','YT',
  'ZA','ZM','ZW',
];

/** Egy kód lokalizált országneve (ismeretlen/hibás → maga a kód). */
export function countryLabel(code: string, locale: string): string {
  const c = code.trim().toUpperCase();
  if (c === '') return code;
  try {
    return new Intl.DisplayNames([locale], { type: 'region' }).of(c) ?? c;
  } catch {
    return c;
  }
}

/** A teljes ország-lista a UI nyelvén, név szerint rendezve (combobox-opciók). */
export function countryOptions(locale: string): ComboboxOption[] {
  let dn: Intl.DisplayNames | null = null;
  try {
    dn = new Intl.DisplayNames([locale], { type: 'region' });
  } catch {
    dn = null;
  }
  return ISO_ALPHA2.map((code) => ({ id: code, label: dn?.of(code) ?? code })).sort((a, b) =>
    a.label.localeCompare(b.label, locale),
  );
}
